var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookTelephoneBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ff1fe1",
    height: "200px",
    width: "200px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-128 -128 768.00 768.00",
    xmlSpace: "preserve",
    stroke: "#ff1fe1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -128,
    y: -128,
    width: 768,
    height: 768,
    rx: 0,
    fill: "#ffdbfa",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M339.478,0H239.304c-64.445,0-116.87,52.429-116.87,116.87v100.174c0,52.835,35.265,97.539,83.478,111.949v116.225 h-16.696c-27.619,0-50.087,22.468-50.087,50.087c0,9.223,7.479,16.696,16.696,16.696h200.348c9.217,0,16.696-7.473,16.696-16.696 c0-27.619-22.468-50.087-50.087-50.087h-16.696V333.913h33.391c27.619,0,50.087-22.468,50.087-50.087V50.087 C389.565,22.468,367.097,0,339.478,0z M272.696,445.217h-33.391V333.913h33.391V445.217z M294.706,259.397 c-26.624,7.142-54.181-8.707-61.336-35.418c-28.04-104.616-26.332-97.677-26.476-100.098 c-5.022-25.589,10.405-51.151,35.966-58.005c8.815-2.377,18.037,2.822,20.457,11.804l8.642,32.255 c2.388,8.947-2.953,18.084-11.815,20.445l-16.125,4.32l17.291,64.51l16.116-4.318c8.821-2.391,18.041,2.84,20.457,11.804 l8.642,32.255C308.909,247.897,303.569,257.035,294.706,259.397z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookTelephoneBox);
export default __webpack_public_path__ + "static/media/BookTelephoneBox.3c73d450b0972588b289d7d8a344aebd.svg";
export { ForwardRef as ReactComponent };